/**
 * 指挥对话：合并服务端历史（GET /api/tracker/messages/history）与本页内存消息（WS / 刚发出）。
 * 去重规则：
 * - 同 id（入站消息 id 与 WS payload.id 一致）视为同一条
 * - 外发：同 batch_id 视为同一条（内存里是 out_时间戳，历史里是 tc_指令id）
 * 结果按 created_at 旧 → 新。
 */
export function mergeChatHistory(live, history) {
  const out = [];
  const ids = new Set();
  const batches = new Set();
  const add = (m) => {
    if (!m) return;
    const hasMedia = Array.isArray(m.media) && m.media.length > 0;
    if (!m.text && !hasMedia) return;
    if (m.id && ids.has(m.id)) return;
    if (m.direction === 'out' && m.batch_id && batches.has(m.batch_id)) return;
    if (m.id) ids.add(m.id);
    if (m.direction === 'out' && m.batch_id) batches.add(m.batch_id);
    out.push(m);
  };
  (Array.isArray(history) ? history : []).forEach(add);
  (Array.isArray(live) ? live : []).forEach(add);
  return out.sort((a, b) => new Date(a.created_at || 0).getTime() - new Date(b.created_at || 0).getTime());
}